import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.nodes.api.register');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-nodes-api-register',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.nodes.api.register/view.scss */
:host {
  display: block;
  height: 100%;
}

.registration-steps {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
}

.registration-steps li {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px solid #f4f4f5;
  color: #71717a;
  font-size: 13px;
}

.registration-steps li > i {
  font-size: 20px;
  flex: none;
}

.registration-steps li > div {
  flex: 1;
  min-width: 0;
}

.step-name {
  color: #27272a;
  font-weight: 600;
}

.registration-steps small {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: #71717a;
}

.step-state {
  white-space: nowrap;
  font-size: 12px;
}

.registration-progress {
  padding: 20px;
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  background: white;
}

.progress-heading {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}

.progress-heading h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.progress-track {
  margin: 14px 0;
  height: 5px;
  border-radius: 3px;
  background: #e4e4e7;
  overflow: hidden;
}

.progress-track > div {
  height: 100%;
  background: #4f46e5;
  transition: width 0.3s ease;
}

.registration-table-scroll {
  overflow-x: auto;
}

.registration-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  text-align: left;
  font-size: 12px;
}

.registration-table th {
  padding: 10px 12px;
  background: #f4f4f5;
  color: #52525b;
  white-space: nowrap;
  font-weight: 500;
}

.registration-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #e4e4e7;
  white-space: nowrap;
}

.registration-table td small {
  display: block;
  color: #71717a;
  margin-top: 4px;
}

.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.status-cell i {
  font-size: 18px;
}

[data-status=running] {
  color: #4f46e5 !important;
}

[data-status=completed] {
  color: #047857 !important;
}

[data-status=warning], [data-status=unknown] {
  color: #b45309 !important;
}

[data-status=failed], [data-status=rolled_back] {
  color: #b91c1c !important;
}

[data-status=pending], [data-status=skipped] {
  color: #71717a;
}

.progress-note {
  margin-top: 12px;
  font-size: 13px;
  color: #b45309;
}

.registered-node {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  margin-top: 14px;
  font-size: 13px;
  font-weight: 600;
  color: #4338ca;
}

@media (prefers-reduced-motion: reduce) {
  .progress-track > div {
    transition: none;
  }
}`],
})
export class PageKieraNodesApiRegisterComponent implements OnInit, OnDestroy {
    public form: any = { name: '', ip_address: '', ssh_user: 'root', ssh_password: '', ssh_port: 22 };
    public busy = false;
    public error = '';
    public result: any = null;
    public progress: any = null;
    public stepKeys = ['connect', 'scan', 'save', 'kiera_agent', 'zabbix_agent', 'complete'];
    private controller: AbortController | null = null;
    private destroyed = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.controller?.abort();
    }

    public stepStatus(key: string) {
        return this.progress?.steps?.find((step: any) => step.key === key)?.status || 'pending';
    }

    public completedSteps() {
        return this.progress?.steps?.filter((step: any) =>
            ['completed', 'skipped', 'warning'].includes(step.status)).length || 0;
    }

    public icon(status: string) {
        return ({
            running: 'bx bx-loader-alt bx-spin', completed: 'bx bx-check-circle',
            warning: 'bx bx-error', failed: 'bx bx-x-circle',
            skipped: 'bx bx-skip-next-circle', rolled_back: 'bx bx-undo',
            unknown: 'bx bx-help-circle'
        } as any)[status] || 'bx bx-circle';
    }

    public async register() {
        if (this.busy) return;
        this.error = '';
        if (!String(this.form.name || '').trim()) this.error = '노드 이름을 입력하세요.';
        else if (!String(this.form.ip_address || '').trim()) this.error = 'IP 주소를 입력하세요.';
        else if (!String(this.form.ssh_user || '').trim()) this.error = 'SSH 사용자를 입력하세요.';
        else if (!String(this.form.ssh_password || '')) this.error = 'SSH 비밀번호를 입력하세요.';
        else if (!Number.isInteger(Number(this.form.ssh_port)) || Number(this.form.ssh_port) < 1 || Number(this.form.ssh_port) > 65535)
            this.error = 'SSH 포트는 1~65535 사이의 정수여야 합니다.';
        if (this.error) { await this.service.render(); return; }

        const payload = {
            name: String(this.form.name).trim(), ip_address: String(this.form.ip_address).trim(),
            ssh_user: String(this.form.ssh_user).trim(), ssh_password: String(this.form.ssh_password),
            ssh_port: Number(this.form.ssh_port), scan_ssh: true, install_agent: true, update_existing: true
        };
        this.result = null;
        this.progress = {
            name: payload.name, ip_address: payload.ip_address, status: 'running',
            steps: this.stepKeys.map(key => ({ key, status: 'pending' }))
        };
        this.busy = true;
        this.controller = new AbortController();
        await this.service.render();
        let terminal = false;
        try {
            const csrf = document.cookie.split('; ').find(item => item.startsWith('KIERA_CSRF='))?.split('=').slice(1).join('=') || '';
            const response = await fetch('/wiz/api/page.kiera.nodes.api.register/register_progress', {
                method: 'POST', credentials: 'same-origin', signal: this.controller.signal,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-KiERA-CSRF': decodeURIComponent(csrf) },
                body: new URLSearchParams({ data: JSON.stringify(payload) })
            });
            // A JSON error envelope (for example, expired login or invalid CSRF) is not a stream.
            if (!response.ok || !response.headers.get('Content-Type')?.includes('text/event-stream') || !response.body) {
                const failure: any = await response.json().catch(() => ({}));
                throw new Error(failure?.data?.message || '등록 요청을 시작할 수 없습니다.');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            const receive = async (block: string) => {
                const data = block.split('\n').filter(line => line.startsWith('data:'))
                    .map(line => line.slice(5).trimStart()).join('\n');
                if (!data) return;
                const event = JSON.parse(data);
                if (event.progress) this.progress = event.progress;
                if (event.type === 'result') { this.result = event.result; terminal = true; }
                if (event.type === 'error') {
                    this.error = event.progress?.message || '등록에 실패했습니다.';
                    terminal = true;
                }
                if (!this.destroyed) await this.service.render();
            };
            while (true) {
                const chunk = await reader.read();
                buffer += decoder.decode(chunk.value, { stream: !chunk.done }).replace(/\r/g, '');
                let boundary: number;
                while ((boundary = buffer.indexOf('\n\n')) >= 0) {
                    const block = buffer.slice(0, boundary); buffer = buffer.slice(boundary + 2);
                    await receive(block);
                }
                if (terminal) { await reader.cancel(); break; }
                if (chunk.done) { if (buffer.trim()) await receive(buffer); break; }
            }
            if (!terminal) throw new Error('연결이 끊어졌습니다. 노드 목록에서 등록 결과를 확인하세요.');
        } catch (error: any) {
            if (!this.destroyed) {
                this.error = error?.message || '등록 상태를 확인할 수 없습니다.';
                if (this.progress?.status === 'running') {
                    this.progress.status = 'unknown';
                    this.progress.steps = this.progress.steps.map((step: any) =>
                        step.status === 'running' ? { ...step, status: 'unknown' } : step);
                }
            }
        } finally {
            this.form.ssh_password = '';
            payload.ssh_password = '';
            this.busy = false;
            this.controller = null;
            if (!this.destroyed) await this.service.render();
        }
    }

    public downloadInstaller() {
        const scripts = [
            String(this.result?.agent?.install_script || ''),
            String(this.result?.zabbix_agent?.install_script || ''),
        ].filter((script: string) => !!script)
            .map((script: string) => script.replace(/^#![^\n]*\n?/, ''));
        const script = ['#!/bin/bash', 'set -e', ...scripts].join('\n\n');
        const nodeId = this.result?.node?.id;
        if (!script || !nodeId) return;
        const url = URL.createObjectURL(new Blob([script], { type: 'text/x-shellscript;charset=utf-8' }));
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `kiera-node-agents-install-${nodeId}.sh`;
        anchor.click();
        URL.revokeObjectURL(url);
    }

    public canDownloadInstaller() {
        const kieraFailed = !!this.result?.agent?.install_script && !this.result?.agent?.installation?.installed;
        const zabbixFailed = !!this.result?.zabbix_agent?.install_script && !this.result?.zabbix_agent?.installation?.installed;
        return kieraFailed || zabbixFailed;
    }
}

export default PageKieraNodesApiRegisterComponent;
